(function () {
  'use strict';

  angular
    .module('UoHelperModule', ['enumModule'])
    .factory('UoHelperService', UoHelperService);

  function UoHelperService(RootUoEnum) {
    const service = {
      isRoot,
      isDirectChildOfRoot
    };

    return service;

    function isRoot(uoId) {
      return RootUoEnum.getIds().includes(Number(uoId));
    }

    function isDirectChildOfRoot(uo) {
      return isRoot(uo && uo.uoPai && uo.uoPai.id);
    }
  }
}());
